"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function isActor(item) {
  try {
    return typeof item.send === 'function';
  } catch (e) {
    return false;
  }
}
exports.isActor = isActor;